<template>
  <common-card class="mt-3">
    <v-row>
      <v-col>
        <v-row style="padding: 15px 20px 0px 20px;">
          <v-col cols="12">
            <h1>
              {{ isEditing ? "Editar" : "Crear" }}
              {{ isEditing ? beneficio.tipo : "Asistencia o Beneficio" }}
            </h1>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-container>
      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="container-pefai-cards">
          <v-row class="padding-pefai">
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="beneficio.alianza_intermx_id"
                label="Alianza Inter.mx*"
                :items="alianzasOptions"
                item-text="nombre"
                item-value="id"
                :rules="[rules.required]"
                :disabled="isEditing"
                outlined
                @change="onAlianzaChange"
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="beneficio.producto_ids"
                label="Productos a los que pertenece*"
                :items="productosOptions"
                item-text="nombre"
                item-value="id"
                :rules="[rules.requiredArray]"
                :disabled="!beneficio.alianza_intermx_id"
                multiple
                chips
                small-chips
                deletable-chips
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="beneficio.tipo"
                label="Tipo*"
                :items="tiposOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="beneficio.categoria"
                label="Categoria*"
                :items="categoriasOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="beneficio.nombre"
                label="Nombre*"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="beneficio.nombre_corto"
                label="Nombre Corto para envio de SMS*"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea
                v-model="beneficio.descripcion"
                label="Descripción*"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
                no-resize
                rows="1"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="beneficio.monto"
                label="Monto del beneficio*"
                type="number"
                min="0"
                step="0.01"
                :rules="[rules.required, rules.number]"
                outlined
                color="#00a7e4"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="beneficio.periodicidad"
                label="Periodicidad*"
                :items="periodicidadOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="beneficio.mes_disponibilidad"
                label="Mes de Disponibilidad"
                type="number"
                min="1"
                max="12"
                hint="Ingresa un número del 1 al 12"
                outlined
                color="#00a7e4"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="beneficio.eventos_periodo"
                label="Eventos por Periodo*"
                type="number"
                min="1"
                :rules="[rules.required, rules.integer]"
                outlined
                color="#00a7e4"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="beneficio.proveedor"
                item-text="nombre"
                item-value="id"
                label="Proveedor*"
                :items="proveedorOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="beneficio.codigo_proveedor_id"
                label="Codigo Proveedor"
                type="number"
                outlined
                color="#00a7e4"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="beneficio.costo_promedio"
                label="Costo promedio*"
                type="number"
                step="0.01"
                min="0"
                outlined
                color="#00a7e4"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="beneficio.sla"
                label="SLA*"
                type="number"
                min="1"
                :rules="[rules.required, rules.integer]"
                outlined
                color="#00a7e4"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="beneficio.especial"
                label="Especial*"
                item-text="text"
                item-value="value"
                :items="especialOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="beneficio.familiar"
                label="¿Es un beneficio para redimir para múltiples familiares?*"
                item-text="text"
                item-value="value"
                :items="familiarOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="beneficio.telefonia"
                label="Telefonía*"
                item-text="text"
                item-value="value"
                :items="telefoniaOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" v-if="isEditing">
              <v-autocomplete
                v-model="beneficio.status"
                label="Estatus*"
                :items="statusOptions"
                :rules="[rules.required]"
                outlined
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </div>

        <v-row class="mt-5">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              rounded
              dark
              outlined
              color="#00a7e4"
              class="mr-4"
              @click="$router.push('/administracion/asistencias-beneficios')"
            >
              Cancelar
            </v-btn>
            <v-btn
              rounded
              dark
              class="common-botton"
              :loading="loading"
              @click="guardarBeneficio"
            >
              {{ isEditing ? "Actualizar" : "Crear" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </common-card>
</template>

<script>
import { mainAxios } from "../../../../mainAxios";
import { getAlianzas } from "../../../../services/alianzas/alianzas.service";
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import {
  getCategorias,
  getProveedor,
} from "../../../../services/clubBeneficios/clubBeneficios";

export default {
  name: "FormularioBeneficio",
  components: {
    CommonCard,
  },
  data() {
    return {
      valid: true,
      loading: false,
      beneficio: {
        nombre: "",
        nombre_corto: "",
        descripcion: "",
        alianza_intermx_id: null,
        producto_ids: [],
        periodicidad: "",
        mes_disponibilidad: null,
        status: "Activo",
        monto: 0,
        eventos_periodo: 1,
        tipo: "",
        codigo_proveedor_id: null,
        categoria: "",
        costo_promedio: 0,
        sla: 0,
        especial: null,
        proveedor: 0,
        familiar: null,
        telefonia: null,
      },
      rules: {
        required: (value) =>
          value !== null && value !== undefined
            ? true
            : "Este campo es requerido",
        number: (value) =>
          (!isNaN(value) && value >= 0) ||
          "Debe ser un número válido mayor o igual a 0",
        integer: (value) =>
          (Number.isInteger(Number(value)) && Number(value) > 0) ||
          "Debe ser un número entero mayor a 0",
        requiredArray: (value) =>
          (Array.isArray(value) && value.length > 0) || "Selecciona al menos un producto",
      },
      statusOptions: [],
      periodicidadOptions: [],
      productosOptions: [],
      tiposOptions: [],
      alianzasOptions: [],
      proveedorOptions: [],
      categoriasOptions: [],
      especialOptions: [
        { value: 1, text: "Si" },
        { value: 0, text: "No" },
      ],
      familiarOptions: [
        { value: 1, text: "Si" },
        { value: 0, text: "No" },
      ],
      telefoniaOptions: [
        { value: true, text: "Si" },
        { value: false, text: "No" },
      ],
    };
  },
  computed: {
    isEditing() {
      return this.$route.params.id ? true : false;
    },
  },
  mounted() {
    this.getStatusOptions();
    this.getPeriodicidadOptions();
    this.getTiposOptions();
    this.getAlianzasOptions();
    this.getProveedorOptions();
    this.getCategoriasOptions();
    if (this.isEditing) {
      this.getBeneficio();
    }
  },
  methods: {
    async getAlianzasOptions() {
      this.alianzasOptions = await getAlianzas();
    },
    async getProveedorOptions() {
      this.proveedorOptions = await getProveedor();
    },
    async getCategoriasOptions() {
      this.categoriasOptions = await getCategorias();
    },
    getTiposOptions() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      mainAxios
        .get("/v1/club-beneficios/tipos", config)
        .then((response) => {
          this.tiposOptions = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener status:", error);
        });
    },
    onAlianzaChange(alianzaId) {
      this.beneficio.producto_ids = [];
      this.getProductosOptions(alianzaId);
    },

    getProductosOptions(alianzaId) {
      this.productosOptions = [];
      if (!alianzaId) return;
      const config = {
        headers: { Authorization: "Bearer " + localStorage.agenteAccessToken },
      };
      mainAxios
        .get(`/v1/productos/alianza/${alianzaId}`, config)
        .then((response) => {
          this.productosOptions = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener productos:", error);
        });
    },
    getStatusOptions() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      mainAxios
        .get("/v1/club-beneficios/status", config)
        .then((response) => {
          this.statusOptions = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener status:", error);
        });
    },

    getPeriodicidadOptions() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      mainAxios
        .get("/v1/club-beneficios/periodicidades", config)
        .then((response) => {
          this.periodicidadOptions = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener periodicidades:", error);
        });
    },

    getBeneficio() {
      this.loading = true;
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      mainAxios
        .get(`/v1/club-beneficios/${this.$route.params.id}`, config)
        .then((response) => {
          const beneficioData = response.data.data;
          this.beneficio = {
            nombre: beneficioData.nombre,
            nombre_corto: beneficioData.nombreCorto,
            descripcion: beneficioData.descripcion,
            producto_ids: beneficioData.productoIds || [],
            alianza_intermx_id: Number(beneficioData.alianzaIntermxId),
            periodicidad: beneficioData.periodicidad,
            mes_disponibilidad: beneficioData.mesDisponibilidad,
            status: beneficioData.status,
            monto: beneficioData.monto,
            eventos_periodo: beneficioData.eventosPeriodo,
            codigo_proveedor_id: beneficioData.codigoProveedorId,
            tipo: beneficioData.tipo,
            categoria: beneficioData.categoria,
            proveedor: Number(beneficioData.asistenciadoraId),
            costo_promedio: beneficioData.costo_promedio,
            sla: beneficioData.sla,
            especial: beneficioData.especial,
            familiar: beneficioData.familiar,
            telefonia: this.normalizeBoolean(beneficioData.telefonia),
          };
          this.getProductosOptions(this.beneficio.alianza_intermx_id);
          console.log("intermxid ", this.beneficio);
        })
        .catch((error) => {
          console.error("Error al obtener beneficio:", error);
          this.$toast.error("Error al cargar el beneficio", {
            position: "top-right",
            timeout: 3000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    normalizeBoolean(value) {
      if (value === null || value === undefined) return null;
      if (value === "false" || value === "0" || value === 0) return false;
      return Boolean(value);
    },

    guardarBeneficio() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const config = {
          headers: {
            Authorization: "Bearer " + localStorage.agenteAccessToken,
          },
        };

        const beneficioPayload = {
          nombre: this.beneficio.nombre,
          nombre_corto: this.beneficio.nombre_corto,
          descripcion: this.beneficio.descripcion,
          producto_ids: this.beneficio.producto_ids,
          alianza_intermx_id: this.beneficio.alianza_intermx_id.toString(),
          periodicidad: this.beneficio.periodicidad,
          mes_disponibilidad: this.beneficio.mes_disponibilidad,
          status: this.beneficio.status,
          monto: this.beneficio.monto,
          eventos_periodo: this.beneficio.eventos_periodo,
          codigo_proveedor_id: this.beneficio.codigo_proveedor_id,
          tipo: this.beneficio.tipo,
          categoria: this.beneficio.categoria,
          asistenciadora_id: this.beneficio.proveedor,
          costo_promedio: this.beneficio.costo_promedio,
          sla: this.beneficio.sla,
          especial: this.beneficio.especial,
          familiar: this.beneficio.familiar,
          telefonia: this.beneficio.telefonia,
        };

        const endpoint = this.isEditing
          ? `/v1/club-beneficios/${this.$route.params.id}`
          : "/v1/club-beneficios/";

        mainAxios
          .post(endpoint, beneficioPayload, config)
          .then(() => {
            this.$toast.success(
              this.isEditing
                ? "Beneficio actualizado correctamente"
                : "Beneficio creado correctamente",
              {
                position: "top-right",
                timeout: 3000,
              },
            );

            this.$router.push("/administracion/asistencias-beneficios");
          })
          .catch((error) => {
            console.error("Error al guardar beneficio:", error);
            const mensaje = error.response?.data || `Error desconocido al ${this.isEditing ? "actualizar" : "crear"} el beneficio`;
            this.$toast.error(mensaje,
              {
                position: "top-right",
                timeout: 3000,
              },
            );
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.v-text-field--outlined fieldset {
  border-color: rgba(0, 0, 0, 0.12);
}

.common-botton {
  background-color: #00a7e4 !important;
}
</style>
